<template>
  <div
    :class="`${getDivHelper()} ${vx_isScrollLocked?'home-lock-scroll':''}`"
    v-loading.fullscreen="!fs&&!hideLoading"
  >
    <div v-preloading.opacity="delay&&!fs">
      <!--页面头部-->
      <Header></Header>
      <router-view v-title="$route.meta.title"></router-view>
      <Footer v-preloading.opacity="!fs"></Footer>
    </div>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  computed: {
    hideLoading() {
      return this.$route.meta.hideLoading;
    }
  },
  watch: {
    vx_isReady(v) {
      if (this.usePageReady) {
        this.fs = v;
      }
    }
  },
  data: () => {
    return {
      apiData: "",
      fs: false,
      delay: true,
      usePageReady: false
    };
  },
  methods: {
    getDivHelper() {
      return this.$route.meta.divHelper;
    }
  },
  created() {
    this.fs = false;
    this.$router.afterEach((to, from) => {
      if (to.meta.scrollLocked) {
        this.vx_lockScroll();
      } else {
        this.vx_releaseScroll();
      }
      this.usePageReady = to.meta.usePageReady;
      this.delay = to.meta.delay > 0 || this.usePageReady;
      if (!this.usePageReady) {
        if (to.meta.delay) {
          setTimeout(() => {
            this.fs = true;
          }, to.meta.delay || 0);
        } else {
          this.fs = true;
        }
      }
    });
  }
};
</script>
<style lang="scss">
.home-lock-scroll {
  overflow: hidden !important;
}
</style>
